<section id="casos-exito" class="modern-portfolio-section modern-section dingo-section dingo-bg-base">
  <div class="container">
    <div class="portfolio-section-head">
      <div class="portfolio-section-copy home-section-head section-head reveal-on-scroll" data-reveal="section-head">
        <p class="home-section-kicker">Casos de éxito</p>
        <h2 class="home-section-title">
          Proyectos que <span class="highlight-green">aceleraron resultados</span>
        </h2>
        <p class="home-section-desc">
          Estrategia, creatividad, tecnología y ejecución con impacto medible en negocio.
        </p>
      </div>
      <aside class="portfolio-section-snapshot reveal-on-scroll" data-reveal="card" style="--reveal-order: 2">
        <span>Impacto medible</span>
        <strong>+100</strong>
        <small>historias de crecimiento</small>
      </aside>
    </div>
    <div class="portfolio-case-grid">
      @for (caseItem of portfolioCases; track caseItem.title; let i = $index) {
      <article class="case-card reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i % 3">
        <div class="case-card-media">
          <img class="img-fluid" [src]="caseItem.image" [alt]="caseItem.title" loading="lazy" />
          <span class="case-card-index">{{ i + 1 | number: '2.0' }}</span>
          <span class="case-card-industry">{{ caseItem.industry }}</span>
        </div>
        <div class="case-card-body">
          <div class="case-card-title-row">
            <h3>{{ caseItem.title }}</h3>
            <p class="case-card-metric">{{ caseItem.metric }}</p>
          </div>
          <p class="case-card-description">{{ caseItem.description }}</p>
          <a class="case-card-link" [routerLink]="caseItem.link">
            Ver caso completo
            <i class="bi bi-arrow-right"></i>
          </a>
        </div>
      </article>
      }
    </div>
  </div>
</section>
